import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageModule } from '../../atoms/image/image.module';
import { BannerFullimageComponent } from './banner-fullimage.component';

@NgModule({
  imports: [CommonModule, ImageModule],
  declarations: [BannerFullimageComponent],
  exports: [BannerFullimageComponent]
})
export class BannerFullimageModule {}
